import useCountdownTimer from '@src/hooks/UseCountDown';
import { useAppDispatch, useAppSelector } from '@src/core/hooks';
import {
  buyerSelector,
  errorsSelector,
  phoneVerificationSelector,
  requestPhoneVerification,
  verifyPhone,
} from '@src/features/auth';

const usePhoneVerification = () => {
  const dispatch = useAppDispatch();

  const [buyer] = useAppSelector(buyerSelector);
  const contextErrors = useAppSelector(errorsSelector);
  const { requestLockedUntil, status, loading } = useAppSelector(phoneVerificationSelector);

  const { minutes, seconds, isOver } = useCountdownTimer(
    requestLockedUntil ? new Date(requestLockedUntil) : new Date(),
  );

  const sendCode = () => {
    dispatch(requestPhoneVerification());
  };

  const submit = (code: string) => {
    dispatch(verifyPhone({ code }));
  };

  return {
    buyer,
    minutes,
    seconds,
    isOver,
    loading,
    sendCode,
    submit,
    status,
    contextErrors,
  };
};

export default usePhoneVerification;
